import { putCoreSonarObjectsUsersBulkSlice } from './put';

export const {
	requestPutCoreSonarObjectsUsersBulk,
	resetPutCoreSonarObjectsUsersBulk
} = putCoreSonarObjectsUsersBulkSlice.asyncActionCreators;
